let isLoadingMore = false;
let currentObserver = null;

const loadItems = (button) => {
  if (isLoadingMore) return;
  isLoadingMore = true;

  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage+1;
  const nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  const nextUrlScroll = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPageScroll);
  $('[data-current-page]').val(currentPage);

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      const existingIds = new Set(
        [...document.querySelectorAll('.load-more-grid [data-product-id]')]
          .map(el => el.dataset.productId)
      );
      $(responseHTML).find('.load-more-grid .collection-product-card').each(function() {
        if (!existingIds.has(String($(this).data('product-id')))) {
          $('.load-more-grid').append($(this));
        }
      });
      colorSwatches();
    },
    complete: function() {
      isLoadingMore = false;
      if (currentPage <= totalPages) {
        const scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPages) {
          scollData.querySelector('input[data-next-url]').dataset.nextUrl =  nextUrlScroll;
          scollData.querySelector('input[data-next-url]').value =  nextUrlScroll;
          scollData.querySelector('input[data-current-page]').dataset.currentPage =  currentPage;
          scollData.querySelector('input[data-current-page]').value =  currentPage;
          checkVisibility();
        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }
      }
    }
  })
}

const checkVisibility = () => {
  if (currentObserver) {
    currentObserver.disconnect();
    currentObserver = null;
  }
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach(spinner => {
    currentObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            currentObserver.disconnect();
            currentObserver = null;
            loadItems(spinner);
          }
        })
      }
    );

    currentObserver.observe(spinner);
  })
}

function loadMore() {  
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  checkVisibility();
}

(function () {
  loadMore();
})();